// removed by extract-text-webpack-plugin
module.exports = {"icon":"ToolTipCustom__icon___3mwfOc7","container":"ToolTipCustom__container___1CgReD0","label":"ToolTipCustom__label___1xUlZR9","tooltip":"ToolTipCustom__tooltip___eGQHCjx"};